(function($) {

  var $inView = false;

  if($inView == false){
    $(window).on('scroll', function() {
      var $div = $('.fadein-railcar-block .container');
      var divTop = $div.offset().top;
      var divHeight = $div.outerHeight();
      var windowHeight = $(window).height();
      var scrollTop = $(window).scrollTop();
      
      if (scrollTop + windowHeight > divTop && scrollTop < divTop + divHeight) {
        // the div is visible in the viewport
        $($div).find('img').each(function(index) {
          $(this).delay(10*index).queue(function() {
            $(this).css('visibility', 'visible');
            $(this).addClass('animated fadeIn').dequeue();
          });
        });

        $inView = true;
      }
    });
  };

})(jQuery); // Fully reference jQuery after this point.